import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  AccountEvent,
  AccountEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/crm/v1/account_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { AccountCreatedDetail } from './AccountCreatedDetail';
import { AccountDeletedDetail } from './AccountDeletedDetail';
import { AccountUpdatedDetail } from './AccountUpdatedDetail';

type AccountEventDetailProps = {
  payload: string;
};

export const AccountEventDetail = ({ payload }: AccountEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): AccountEvent | null => {
    try {
      return fromJson(AccountEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <AccountCreatedDetail event={inner.value} />;
      case 'updated':
        return <AccountUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <AccountDeletedDetail event={inner.value} />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = () => {
    switch (inner.case) {
      case 'created':
        return 'Account Created';
      case 'updated':
        return 'Account Updated';
      case 'deleted':
        return 'Account Deleted';
      case undefined:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@AccountEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
